"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var LANG_ROUTE = 'upgrades.activationModal';

var ActivationErrorModal = function ActivationErrorModal() {
  return _react.default.createElement(_UIModal.default, {
    size: "auto",
    use: "conversational",
    width: 500
  }, _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UIErrorMessage.default, null, _react.default.createElement("p", {
    className: "m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + ".errorTitle"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + ".errorMessage"
  })))));
};

var _default = ActivationErrorModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/ActivationErrorModal.js
// module id = 335
// module chunks = 5 6